import * as React from 'react';
import type { SVGProps } from 'react';
const SvgRulesLine = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M17.175 3.202a.54.54 0 0 1 0 .764l-1.718 1.718a.63.63 0 0 1-.891 0l-.852-.851a.54.54 0 0 1 .765-.765l.533.533 1.399-1.4a.54.54 0 0 1 .764 0Zm0 5.355a.54.54 0 0 1 0 .765l-1.718 1.718a.63.63 0 0 1-.891 0l-.852-.852a.54.54 0 0 1 .765-.764l.533.533 1.399-1.4a.54.54 0 0 1 .764 0"
      clipRule="evenodd"
    />
    <path d="M15.954 16.798a.54.54 0 0 0 .764-.764l-.509-.509.509-.508a.54.54 0 0 0-.764-.765l-.509.509-.509-.509a.54.54 0 0 0-.764.765l.509.508-.509.509a.54.54 0 1 0 .764.764l.509-.509.509.51ZM2.667 4.456a.75.75 0 0 1 .75-.75h7.56a.75.75 0 0 1 0 1.5h-7.56a.75.75 0 0 1-.75-.75m0 5.356a.75.75 0 0 1 .75-.75h7.56a.75.75 0 0 1 0 1.5h-7.56a.75.75 0 0 1-.75-.75m0 5.693a.75.75 0 0 1 .75-.75h7.56a.75.75 0 0 1 0 1.5h-7.56a.75.75 0 0 1-.75-.75" />
  </svg>
);
export default SvgRulesLine;
